// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"c7cbc62c","255":"47b2454b","499":"d0997ebe","527":"487926a4","531":"a27eecec","540":"b9555a54","568":"7a3d6ce2","572":"2d9fb844","648":"03f354e0","733":"08e2c064","929":"895f55c7","961":"2365e85a","978":"2b52c288"}[chunkId] + ".chunk.js";
};